<script setup>
const props = defineProps({
    requestUrl: { type: String, required: true, },
    buttonClass: { type: String, required: true },
    isFree: { type: Boolean, required: true },
    isGiftCardPurchasable: { type: Boolean, required: true },
    giftCardBalance: { type: Number, default: null },
});
</script>
<template>
    <purchase-button-base
        v-if="isFree"
        :request-url="requestUrl"
        :button-class="buttonClass"
        @success="$document.locationAssign($event.responseData.location)"
    >
        <template #default><slot></slot></template>
    </purchase-button-base>

    <purchase-button-base
        v-else-if="isGiftCardPurchasable"
        :request-url="requestUrl"
        :request-data="{ payment_method: 'gift-card' }"
        :button-class="buttonClass"
        @success="$document.locationAssign($event.responseData.location)"
    >
        <template #default><slot></slot> ({{ _mft('subscription:withCoupon') }})</template>
    </purchase-button-base>

    <purchase-button-cash
        v-else
        :request-url="requestUrl"
        :button-class="buttonClass"
        :payment-methods="['credit-card', 'invoice']"
        :gift-card-balance="giftCardBalance"
    >
        <template #default><slot></slot></template>
    </purchase-button-cash>
</template>
